/*
 * @Author: 刑天
 * @Date: 2022-04-15 10:19:36
 * @LastEditTime: 2023-12-22 15:12:12
 * @Description: 战神
 */
import request from '@/utils/request';

//查询裂变列表
export function getFissionActivitiesPage(values) {
  return request('/activityFission/queryFissionActivitiesPage', {
    method: 'POST',
    data: values,
  });
}

//场景营销列表停止活动
export function terminateActivityFission(values) {
  return request('/activityFission/terminateActivityFission', {
    method: 'POST',
    data: values,
  });
}

//场景营销列表审核活动
export function approveActivityFission(values) {
  return request('/activityFission/approveActivityFission', {
    method: 'POST',
    data: values,
  });
}
//更新或保存裂变活动
export function insertAndUpdateActivityFission(values) {
  return request('/activityFission/insertAndUpdateActivityFission', {
    method: 'POST',
    data: values,
  });
}
//裂变活动详情
export function getActivityFissionDetail(values) {
  return request('/activityFission/queryActivityFissionDetail', {
    method: 'POST',
    data: values,
  });
}
//删除
export function deleteActivityFission(values) {
  return request('/activityFission/deleteActivityFission', {
    method: 'POST',
    data: values,
  });
}
//查询裂变活动报表-助力排行
export function queryFissionRankingReport(values) {
  return request('/activityFission/queryFissionRankingReport', {
    method: 'POST',
    data: values,
  });
}
